import { render, staticRenderFns } from "./project-detail.vue?vue&type=template&id=17c39eed&"
import script from "./project-detail.vue?vue&type=script&lang=ts&"
export * from "./project-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports